import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/styles/globals.css';
import { tenantSlugFromPath } from '@/lib/env';
import { registerServiceWorker } from '@/lib/push';
import { App } from '@/app/App';
import { RootPage } from '@/app/RootPage';

const slug = tenantSlugFromPath();

// Safety net: if a host served the generic shell, attach this studio's manifest
// and icon at runtime so installing still produces the right app.
if (slug && !document.querySelector('link[rel="manifest"]')) {
  const add = (rel: string, href: string) => {
    const l = document.createElement('link');
    l.rel = rel;
    l.href = href;
    document.head.appendChild(l);
  };
  add('manifest', `/s/${slug}/manifest.webmanifest`);
  add('apple-touch-icon', `/s/${slug}/apple-touch-icon.png`);
}
const root = createRoot(document.getElementById('root')!);

root.render(<StrictMode>{slug ? <App slug={slug} /> : <RootPage />}</StrictMode>);

if (slug) void registerServiceWorker(slug);
